import React, { useEffect, useState } from "react";
// import { ChatContainer } from "../../src/ChatContainer";
import { ChatContainer } from "@alku/cactai-fe";
import { AuthProvider } from "./auth/hooks/useAuth";
import { MsalProvider } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import msalInstance from "./auth/msal/msal-instance";
import "./standalone.css";
import { User } from "./types/User";

export function App() {

  const [user] = useState<User | null>(JSON.parse(localStorage.getItem("userData") || "{}"));
  const [isCactAIWhitelisted, setIsCactAIWhitelisted] = useState<boolean>(false);
  useEffect(() => {
    setIsCactAIWhitelisted(user?.features?.cactAI === true);
  }, [user]);
  useEffect(() => {
    (window as any).msalInstance = msalInstance;
  }, []);

  return (
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          {isCactAIWhitelisted ? (
            <ChatContainer standalone={process.env.STANDALONE ? true : false}/>
          ) : (
            <div className="unauthorized-container">
              <h1>You are not authorized to use CactAI. Please contact the Product and Engineering team to get access.</h1>
            </div>
          )}
        </AuthProvider>
      </MsalProvider>
    </BrowserRouter>
  );
}
